module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-14.svg?8c60f526cfe8d70cd8a62d3da3437ef2";